import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.join.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { DeriveJunction } from "./DeriveJunction.js";
var RE_JUNCTION = /\/(\/?)([^/]+)/g;
/**
 * @description Extract derivation junctions from the supplied path
 */

export function keyExtractPath(derivePath) {
  var parts = derivePath.match(RE_JUNCTION);
  var path = [];
  var constructed = '';

  if (parts) {
    constructed = parts.join('');

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        path.push(DeriveJunction.from(p.substring(1)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  assert(constructed === derivePath, function () {
    return "Re-constructed path \"".concat(constructed, "\" does not match input");
  });
  return {
    parts: parts,
    path: path
  };
}